import React from 'react';
import { useEffect } from 'react';

const Sitemap = () => {
    useEffect(() => {
        const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
      <url><loc>${window.location.origin}/</loc></url>
      <url><loc>${window.location.origin}/signin</loc></url>
      <url><loc>${window.location.origin}/signup</loc></url>
      <url><loc>${window.location.origin}/forgot</loc></url>
      <url><loc>${window.location.origin}/reset-password</loc></url>
      <url><loc>${window.location.origin}/home</loc></url>
      <url><loc>${window.location.origin}/create</loc></url>
      <url><loc>${window.location.origin}/topics</loc></url>
      <url><loc>${window.location.origin}/course</loc></url>
      <url><loc>${window.location.origin}/certificate</loc></url>
      <url><loc>${window.location.origin}/profile</loc></url>
      <url><loc>${window.location.origin}/pricing</loc></url>
      <url><loc>${window.location.origin}/features</loc></url>
      <url><loc>${window.location.origin}/blogs</loc></url>
      <url><loc>${window.location.origin}/about</loc></url>
      <url><loc>${window.location.origin}/payment</loc></url>
      <url><loc>${window.location.origin}/success</loc></url>
      <url><loc>${window.location.origin}/subscription</loc></url>
      <url><loc>${window.location.origin}/contact</loc></url>
      <url><loc>${window.location.origin}/terms</loc></url>
      <url><loc>${window.location.origin}/privacy</loc></url>
      <url><loc>${window.location.origin}/cancellation</loc></url>
      <url><loc>${window.location.origin}/refund</loc></url>
      <url><loc>${window.location.origin}/billing</loc></url>
      <url><loc>${window.location.origin}/calendar</loc></url>
      <url><loc>${window.location.origin}/admin/blogs</loc></url>
      <url><loc>${window.location.origin}/admin/blog/create</loc></url>
      <url><loc>${window.location.origin}/dashboard</loc></url>
    </urlset>`;

        const blob = new Blob([sitemapXml], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        window.location.href = url;
    }, []);

    return null;
};

export default Sitemap;
